/**
 * Gestor de carga dinámica de módulos
 */

// Cambia en cada build: el HTML y el CSS de los módulos no llevan hash y el navegador
// los guardaría en caché entre despliegues.
// En desarrollo cambia en cada carga: el servidor de Vite no reinicia al editar un módulo.
const BUILD_ID = import.meta.env?.DEV || typeof __KIOSKO_BUILD__ === 'undefined'
  ? String(Date.now())
  : __KIOSKO_BUILD__;

const modules = {
  fichajes: null,
  ordenes: null,
  material: null,
  calendario: null,
  avance: null
};

/**
 * Carga el HTML de un módulo en el contenedor
 */
async function loadModuleHTML(moduleName, container) {
  try {
    const response = await fetch(`./modules/${moduleName}/${moduleName}.html?v=${BUILD_ID}`);
    if (!response.ok) throw new Error(`Failed to load ${moduleName}.html`);
    
    const html = await response.text();
    container.innerHTML = html;
    
    console.log(`✅ HTML de ${moduleName} cargado`);
  } catch (error) {
    console.error(`❌ Error cargando HTML de ${moduleName}:`, error);
    container.innerHTML = `<p>Error cargando módulo ${moduleName}</p>`;
  }
}

/**
 * Carga el CSS de un módulo
 */
function loadModuleCSS(moduleName) {
  const cssId = `${moduleName}-css`;
  
  // Si ya está cargado, no lo volvemos a cargar
  if (document.getElementById(cssId)) return;
  
  const link = document.createElement('link');
  link.id = cssId;
  link.rel = 'stylesheet';
  link.href = `./modules/${moduleName}/${moduleName}.css?v=${BUILD_ID}`;
  document.head.appendChild(link);
  
  console.log(`✅ CSS de ${moduleName} cargado`);
}

/**
 * Carga el JS de un módulo
 */
async function loadModuleJS(moduleName) {
  try {
    const module = await import(`./modules/${moduleName}/${moduleName}.js`);
    modules[moduleName] = module;
    
    // Inicializar el módulo si tiene función init
    if (module[`init${capitalize(moduleName)}`]) {
      module[`init${capitalize(moduleName)}`]();
    }
    
    console.log(`✅ JS de ${moduleName} cargado`);
  } catch (error) {
    console.error(`❌ Error cargando JS de ${moduleName}:`, error);
  }
}

/**
 * Carga un módulo completo (HTML + CSS + JS)
 */
export async function loadModule(moduleName, container) {
  console.log(`📦 Cargando módulo: ${moduleName}`);
  
  // Cargar CSS (solo una vez)
  loadModuleCSS(moduleName);
  
  // Cargar HTML
  await loadModuleHTML(moduleName, container);
  
  // Cargar JS
  await loadModuleJS(moduleName);
}

/**
 * Limpia un módulo cuando se sale de él
 */
export function unloadModule(moduleName) {
  const module = modules[moduleName];
  
  if (module && module.cleanup) {
    module.cleanup();
  }
  
  console.log(`🧹 Módulo ${moduleName} limpiado`);
}

// Utilidad
function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
